import React from 'react';

import gradient from 'components/animations/gradient.module.scss';
import Line from 'components/Loader/Line';

const MonthsSkeleton = () => {
  const items = [];
  const style = { height: 24, width: 70, borderRadius: 16 };

  for (let index = 0; index < 9; index += 1) {
    items.push(<Line key={Math.random()} gradient={gradient.gradient} style={style} className='mx-1' />);
  }

  return <div className='d-flex align-items-center justify-content-between flex-1 mx-5'>{items}</div>;
};

export default MonthsSkeleton;
